// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
.container-smart-component .expanded {
  height: 100%;
}

.icon-and-text {
  --padding-component: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.supervision-view .title {
  font-size: 15px;
}
.supervision-view ion-button ion-icon {
  font-size: 50px;
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

app-draggable-slider {
  margin-top: 10px;
}

ion-button {
  width: var(--size-icon-main);
  height: var(--size-icon-main);
  flex-shrink: 0;
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  --background: #E9E9E9;
  --box-shadow: 0;
  --ripple-color: #FFA527;
  color: var(--ion-color-dark);
  --transition: transform .2s ease-out;
}
ion-button.turn-on {
  --background: #FDE90E;
}
ion-button.turn-on ion-icon {
  color: #5d5f64;
}
ion-button ion-icon {
  font-size: 35px;
  color: var(--ion-color-medium);
}
ion-button.ion-activated {
  transform: scale(1.2);
}

.warning {
  font-size: 48px;
  color: #9e0505;
  margin-inline: auto 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-dimmer/widget-dimmer.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAnBE;EACE,YAAA;AAqBJ;;AAjBA;EACE,sBAAA;ECkBE,aAAA;EACA,mBAAA;EACA,SAAA;ADGJ;ACDI;EACI,2BAAA;EACA,iBAAA;ADGR;ACAI;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ADER;ACAQ;EACI,gBAAA;ADEZ;ACEI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;ADAR;;AArCA;ECqDI,eAAA;EACA,gBAAA;ADZJ;;AApCE;EACE,eAAA;AAuCJ;AApCE;EACE,eAAA;AAsCJ;;AAlCA;EC2BI,kFAAA;EACA,WAAA;ADWJ;;AAnCA;EACE,gBAAA;AAsCF;;AAnCA;ECwBI,4BAAA;EACA,6BAAA;EACA,cAAA;EDxBF,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,4BAAA;EACA,oCAAA;AAwCF;AAtCE;EACE,qBAAA;AAwCJ;AAtCI;EACE,cAAA;AAwCN;AApCE;EACE,eAAA;EACA,8BAAA;AAsCJ;AAnCE;EACE,qBAAA;AAqCJ;;AAjCA;EACE,eAAA;EACA,cAAA;EACA,uBAAA;AAoCF","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n  @include external-apparance;\n\n  .expanded {\n    height: 100%;\n  }\n}\n\n.icon-and-text {\n  --padding-component: 0;\n  @include icon-and-text;\n}\n\n.title {\n  @include title-main;\n}\n\n.supervision-view {\n\n  .title {\n    font-size: 15px;\n  }\n\n  ion-button ion-icon {\n    font-size: 50px;\n  }\n}\n\n.container-spinner {\n  @include container-spinenr;\n}\n\napp-draggable-slider {\n  margin-top: 10px;\n}\n\nion-button {\n  @include icon-main;\n  --border-radius: 50%;\n  --padding-start: 0;\n  --padding-end: 0;\n  --background: #E9E9E9;\n  --box-shadow: 0;\n  --ripple-color: #FFA527;\n  color: var(--ion-color-dark);\n  --transition: transform .2s ease-out;\n\n  &.turn-on {\n    --background: #FDE90E;\n\n    ion-icon {\n      color: #5d5f64;\n    }\n  }\n\n  ion-icon {\n    font-size: 35px;\n    color: var(--ion-color-medium);\n  }\n\n  &.ion-activated {\n    transform: scale(1.2);\n  }\n}\n\n.warning {\n  font-size: 48px;\n  color: #9e0505;\n  margin-inline: auto 2px;\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
